<template lang="pug">
  #app
    Items
    Modal
    Loading
</template>

<script>
import {
  // mapState,
  mapActions,
  // mapGetters,
  mapMutations
} from 'vuex'

import Header from '../../components/header.vue'
import Items from '../../components/items.vue'
import Modal from '../../components/modal.vue'
import Loading from '../../components/loading.vue'


export default {
  components: {
    Header,
    Items,
    Modal,
    Loading
  },
  created() {
    this.unsetIndices();
    this.toggleLoading();
    this.toggleScroll();
    window.setTimeout(() => {
      this.fetchIndices({page: this.page, query: this.query})
      this.toggleLoading();
    }, 1000);
    
  },
  methods: {
    ...mapMutations([
      'unsetIndices',
      'updateTaxonomies',
      'toggleScroll',
      'toggleLoading'
    ]),
    ...mapActions([
      'fetchIndices',
      'fetchTaxonomies'
    ]),
  }
}
</script>

<style lang="scss" scoped>
body{
  font-size: 24px;
}
</style>
